import {useSelector} from "react-redux";

export default function transformTranslationsResponse(newTranslations:any, existingTranslations:any) {
  const newData:any = {};
  newData.currentLanguage = newTranslations.language;
  newData.translations = {};
  newData.availableLanguages = newTranslations.availableLanguages;
  Object.keys(existingTranslations).forEach(key => {
    newData.translations[key] = Object.assign(existingTranslations[key], {[newTranslations.language]: newTranslations.translations[key] ? newTranslations.translations[key] : existingTranslations[key]['en']});
  });
  newData.collectedLanguages = Object.keys(newData.translations[Object.keys(newData.translations)[0]]);
  return newData;
}